<template>
  <v-app id="service" style="background-color:#1D5787">
    <v-content>
      <v-container fluid fill-height>
        <v-layout row wrap align-center justify-center>
          <v-flex xs6 sm8 md4>
            <v-card
              align="center"
              class="mx-auto my-12 "
              max-width="850px"
              tile
            >
              <v-card-title><B>Please select service.</B></v-card-title>
              <v-card-text>
                <v-form ref="form_select">
                  <div>
                    <v-text-field
                      :value="hospital_name"
                      label="Hospital Name"
                      disabled
                    ></v-text-field>
                  </div>
                  <div>
                    <v-select
                      v-model="form_select.select"
                      :items="items"
                      :rules="selectRules"
                      label="Choose Service"
                    ></v-select>
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  align="center"
                  color="primary"
                  @click="submit()"
                  tile
                  style="max-width:100%;width:120px"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      form_select: {
        select: ""
      },
      items: [],
      hospital_name: "",
      selectRules: [v => !!v || "Service is required"],
    };
  },
  mounted() {
    this.items = JSON.parse(localStorage.getItem("service"));
    console.log("log==>login", this.items);
    this.hospital_name = this.$cookies.get("info_login").hospital_name_th;
    this.role = this.$cookies.get("info_login").role;
    console.log(this.hospital_name);
    // this.check_service();
    // localStorage.setItem("check-service", JSON.stringify(this.service));
  },
  methods: {
    // check_service() {
    //   if (this.service.length < 2) {
    //     console.log(1);
    //     if (this.service == "cxr") {
    //       console.log("cxr-check");
    //       console.log(this.service);
    //       localStorage.setItem("service_name", "CXR");
    //       this.$router.push("/upload");
    //     } else if (this.service == "ratina") {
    //       console.log("ratina-check");
    //       console.log(this.service);
    //       localStorage.setItem("service_name", "RATINA");
    //       this.$router.push("/upload-ratina");
    //     }
    //   } else {
    //     console.log("please choose service");
    //   }
    // },
    submit() {
      if (!this.$refs.form_select.validate()) {
        return;
      } else {
        if (this.role == "user" || this.role == "superadmin") {
          console.log(this.form_select.select);
          if (this.form_select.select == "cxr") {
            console.log("cxr");
            localStorage.setItem("service_name", "CXR");
            // ==== >   api < ==== //
            window.location.href = process.env.VUE_APP_API + "/cxrservice/upload";
          } else {
            console.log("retina");
            localStorage.setItem("service_name", "RATINA");
            // ==== >   api < ==== //
            window.location.href = process.env.VUE_APP_API + "/retinaservice/upload";
          }
        } else if (this.role == "viewer") {
          /////////////////////////////// Viewer /////////////////////////////////////////
          if (this.form_select.select == "cxr") {
            console.log("cxr");
            localStorage.setItem("service_name", "CXR");
            // ==== >   api < ==== //
            window.location.href = process.env.VUE_APP_API + "/cxrservice/history";
          } else {
            console.log("ratina");
            localStorage.setItem("service_name", "RATINA");
            // ==== >   api < ==== //
            window.location.href = process.env.VUE_APP_API + "/retinaservice/history";
          }
        }
      }
    }
  }
};
</script>

<style></style>
